import { FunctionComponent } from 'react';
import { SimpleGrid } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { ReviewField } from './ReviewField';

type ReviewSummaryGridProps = {
  championshipName: string;
  year: string;
  formatLabel: string;
  totalStages: number;
  totalTeams: number;
};

const PREFIX = 'pages.application_season.components.season_step3';

export const ReviewSummaryGrid: FunctionComponent<ReviewSummaryGridProps> = ({
  championshipName,
  year,
  formatLabel,
  totalStages,
  totalTeams,
}) => {
  const { t } = useTranslation();

  return (
    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={3}>
      <ReviewField
        label={t(`${PREFIX}.fields.championship`)}
        value={championshipName || '-'}
      />
      <ReviewField label={t(`${PREFIX}.fields.year`)} value={year || '-'} />
      <ReviewField label={t(`${PREFIX}.fields.format`)} value={formatLabel || '-'} />
      <ReviewField
        label={t(`${PREFIX}.fields.total_stages`)}
        value={t(`${PREFIX}.total_stages_value`, { count: totalStages })}
      />
      <ReviewField
        label={t(`${PREFIX}.fields.total_teams`)}
        value={t(`${PREFIX}.total_teams_value`, { count: totalTeams })}
      />
    </SimpleGrid>
  );
};
